import { BaseEnvConfigService, ClientApp } from '@ianesthesie-kit/config';
import { User } from '@ianesthesie-kit/services';

export class AppConfigService extends BaseEnvConfigService {
  private static readonly INSTANCE = new AppConfigService();

  private readonly hoopcareUserEmails: Set<string>;

  private constructor() {
    super();
    this.hoopcareUserEmails = new Set<string>([
      'antwpapak@gmail.com',
      'orestes.polyzos@gmail.com',
      'chrisfoa@gmail.com',
      'yassine.moussali@hoopcare.com',
      'adrien.chenderoff@hoopcare.com',
      'adrien.chenderoff@gmail.com',
      'richard.boyer@hoopcare.com'
    ]);
  }

  public get intercomEnabled() {
    return !!this.intercomAppId;
  }

  public get countryBasedOnEnv() {
    if (this.env === 'produs') {
      return 'US';
    }

    if (this.env === 'prodfr') {
      return 'FR';
    }

    return 'FR';
  }

  public get intercomAppId() {
    return process.env.NEXT_PUBLIC_INTERCOM_APP_ID || '';
  }

  public get sentryEnabled() {
    return !!this.sentryDsn && this.env !== 'dev';
  }

  public get sentryDsn() {
    return process.env.NEXT_PUBLIC_SENTRY_DSN || '';
  }

  public get sentrySampleRate() {
    return this.env === 'stg' ? 1 : 0.5;
  }

  public get sentryReplaySessionSampleRate() {
    return 0; // never record without a reason
  }

  public get sentryReplayOnErrorSampleRate() {
    return this.env === 'stg' ? 0 : 1; // capture only prod errors
  }

  public get sentryDebugMode() {
    return this.env === 'stg';
  }

  public get getSentryIgnoreErrors() {
    return [/^Network Error$/, /^annulé$/, /^Cancel rendering route$/];
  }

  public static getInstance() {
    return this.INSTANCE;
  }

  public isHoopcareUser(user: User | null): boolean {
    return !!user?.email && this.hoopcareUserEmails.has(user.email);
  }

  public isAllowedToViewAutomationLogs(user: User | null): boolean {
    if (this.env?.startsWith('prod')) {
      return false;
    }
    return !!user?.email && this.hoopcareUserEmails.has(user.email);
  }

  protected getAppCode(): ClientApp {
    return ClientApp.DOCTOR_DASHBOARD;
  }

  protected getVersionFromPackageJson(): string {
    return process.env.NEXT_PUBLIC_APP_RUNTIME_VERSION ?? 'N/A';
  }
}
